import React from 'react';
import { useIntl } from 'react-intl';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import { TypedMemo } from '../../common/types';
import { useSMLRouter } from '../../../routing/sml/hooks';
import { SMLRoutes } from '../../../routing/sml/SMLRoutes';
import { Panel } from '../components/primitives/Panel';
import { withBrandWord } from '../components/primitives/BrandWord';
import { reviewMessages } from './reviewMessages';
import { trackProductEvent } from '../../analytics/events/music24Events';
import { TRUSTPILOT_REVIEW_URL } from './trustpilot';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the review screen; each part uses its own slice of it */
import styles from './Review.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ReviewThanksProps {
  onEdit: () => void;
}

/**
 * The thank-you state after a send (design review-form a6), with a link to post the review on
 * Trustpilot too (owner, 2026-10-31). The link shows for every rating: Trustpilot forbids invitations
 * picked by sentiment.
 */
const ReviewThanksComponent: React.FC<ReviewThanksProps> = ({ onEdit }) => {
  const intl = useIntl();
  const router = useSMLRouter();

  return (
    <Panel as="section" pad>
      <div className="d-flex flex-column align-items-center text-center gap-3 py-4" role="status">
        <span className={styles.doneMark} aria-hidden="true">
          <FontAwesomeIcon icon={faCheck} />
        </span>
        <h2 className="h4 mb-0">{intl.formatMessage(reviewMessages.thanksTitle)}</h2>
        <p className="mb-0 text-body-secondary">{withBrandWord(intl.formatMessage(reviewMessages.thanksBody))}</p>
        <div className="d-flex flex-wrap justify-content-center gap-2">
          <Button color="secondary" outline onClick={onEdit}>
            {intl.formatMessage(reviewMessages.thanksEdit)}
          </Button>
          <Button
            color="secondary"
            outline
            href={TRUSTPILOT_REVIEW_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackProductEvent('trustpilot_opened')}
          >
            {intl.formatMessage(reviewMessages.thanksTrustpilot)}
          </Button>
          <Button color="primary" onClick={() => router.push(SMLRoutes.home)}>
            {intl.formatMessage(reviewMessages.thanksHome)}
          </Button>
        </div>
      </div>
    </Panel>
  );
};

export const ReviewThanks = TypedMemo(ReviewThanksComponent);
